export default "__VITE_ASSET__dwitEX9a__"